<!-- MODAL transferir -->
<div mdbModal #transferir="mdb-modal" class="modal fade" style="overflow-y: auto;" id="basicExample" tabindex="-1"
  role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
  [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Transferencia cliente - vendedor
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="transferir.hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <form [formGroup]='formHeader' novalidate>
        <div class="modal-body">

          <h4 style="border-bottom: 1px solid #dee2e6">Vendedor Origen</h4>

          <div class="row filtros-body">
            <div class="col" style="max-width: 150px">
              <div class="md-form">
                <input value="" type="text" id="rutvende" class="form-control" placeholder="9.999.999-9" required disabled
                  #rutvende formControlName="rutVendedorOrigen" formatRut />
                <label for="rutvende">RUT vendedor</label>
                <div *ngIf="
                      formHeader.get('rutVendedorOrigen').invalid &&
                      (formHeader.get('rutVendedorOrigen').dirty ||
                      formHeader.get('rutVendedorOrigen').touched)
                  ">
                  <mdb-error *ngIf="formHeader.get('rutVendedorOrigen').hasError('required')">
                    Ingrese rut vendedor
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 300px">
              <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect disabled
                (click)="openModalSeleccionarVendedorOrigen()">
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
              <h6 *ngIf="!vendedorOriginario"  class="text-info" style="display: contents">
                {{ vendedorOrigenSeleccionado?.nombre }}
              </h6>
              <h6 *ngIf="vendedorOriginario"  class="text-info" style="display: contents">
                {{ vendedorOrigenSeleccionado?.nombre }}
              </h6>
            </div>
            <div class="col-md-4" style="display: flex; align-items: center;">
              <mdb-checkbox formControlName="eliminar_vendedor" (change)="OnchangeDeleteVendedor($event)">Eliminar Vendedor Origen</mdb-checkbox>
          </div>
            <div class="col" style="display: flex; align-items: center;">
              <h6>Cliente seleccionados ({{clientesSeleccionados}})</h6>
            </div>
          </div>

          <h6>IPT</h6>

          <div class="row filtros-body readOnlyCheck">

              <div class="col" style="max-width: 150px">

                  <mdb-checkbox [checked]="undefined != returnedTarget ? returnedTarget.lunes : false">Lunes</mdb-checkbox>
              </div>
              <div class="col" style="max-width: 150px">
                  <mdb-checkbox [checked]="undefined != returnedTarget ? returnedTarget.martes : false">Martes</mdb-checkbox>
              </div>
              <div class="col" style="max-width: 150px">
                  <mdb-checkbox [checked]="undefined != returnedTarget ? returnedTarget.miercoles: false">Miércoles</mdb-checkbox>
              </div>
              <div class="col" style="max-width: 150px">
                  <mdb-checkbox [checked]="undefined != returnedTarget ? returnedTarget.jueves: false">Jueves</mdb-checkbox>
              </div>
              <div class="col" style="max-width: 150px">
                  <mdb-checkbox [checked]="undefined != returnedTarget ? returnedTarget.viernes: false">Viernes</mdb-checkbox>
              </div>
              <div class="col"style="max-width: 150px">
                  <mdb-checkbox [checked]="undefined != returnedTarget ? returnedTarget.sabado: false" >Sábado</mdb-checkbox>
              </div>
              <div class="col" style="max-width: 150px">
                  <mdb-checkbox [checked]="undefined != returnedTarget ? returnedTarget.domingo: false">Domingo</mdb-checkbox>
              </div>
              <div class="col" style="max-width: 150px">
                  <mdb-checkbox [checked]="returnedTodos">Todos</mdb-checkbox>
              </div>
          </div>
          <br>

          <h4 class="mt-2" style="border-bottom: 1px solid #dee2e6">Vendedor Destino</h4>

          <div class="row filtros-body">
            <div class="col" style="max-width: 150px">
              <div class="md-form">
                <input value="" type="text" id="rutvende" class="form-control" placeholder="9.999.999-9" required
                  #rutvende formControlName="rutVendedorDestino" formatRut />
                <label for="rutvende">RUT vendedor</label>
                <div *ngIf="
                      formHeader.get('rutVendedorDestino').invalid &&
                      (formHeader.get('rutVendedorDestino').dirty ||
                      formHeader.get('rutVendedorDestino').touched)
                  ">
                  <mdb-error *ngIf="formHeader.get('rutVendedorDestino').hasError('required')">
                    Ingrese rut vendedor
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col d-flex" style="max-width: 300px">
              <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
                (click)="openModalSeleccionarVendedorDestino()">
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
              <h6 class="text-info" style="display: contents">
                {{ vendedorDestinoSeleccionado?.nombre }}
              </h6>
            </div>
            <div class="col" style="display: flex; align-items: center;">
              <mdb-checkbox formControlName="HeredaIPT" [checked]="true" (change)="OnchangeITP($event)">Heredar IPT Vendedor Destino</mdb-checkbox>
            </div>
          </div>

          <h6>IPT</h6>
          <ng-container>
          <div class="row filtros-body" >

            <div class="col" style="max-width: 150px">

                <mdb-checkbox formControlName="lunes" (change)="OnchangeL($event)">Lunes</mdb-checkbox>
            </div>
            <div class="col" style="max-width: 150px">
                <mdb-checkbox formControlName="martes" (change)="OnchangeM($event)">Martes</mdb-checkbox>
            </div>
            <div class="col" style="max-width: 150px">
                <mdb-checkbox formControlName="miercoles" (change)="OnchangeMi($event)">Miércoles</mdb-checkbox>
            </div>
            <div class="col" style="max-width: 150px">
                <mdb-checkbox formControlName="jueves" (change)="OnchangeJ($event)">Jueves</mdb-checkbox>
            </div>
            <div class="col" style="max-width: 150px">
                <mdb-checkbox formControlName="viernes" (change)="OnchangeV($event)">Viernes</mdb-checkbox>
            </div>
            <div class="col"style="max-width: 150px">
                <mdb-checkbox formControlName="sabado" (change)="OnchangeS($event)">Sábado</mdb-checkbox>
            </div>
            <div class="col" style="max-width: 150px">
                <mdb-checkbox formControlName="domingo" (change)="OnchangeD($event)">Domingo</mdb-checkbox>
            </div>
            <div class="col" style="max-width: 150px">
                <mdb-checkbox formControlName="todos" (change)="OnchangeT($event)">Todos</mdb-checkbox>
            </div>
        </div>
          </ng-container>


        </div>
      </form>
      <div class="modal-footer justify-content-between">
        <button type="button" class="btn btn-default waves-light" data-dismiss="modal" (click)="transferir.hide()"
          mdbWavesEffect>
          Cerrar
        </button>
        <app-api-button (click2)="transferirVendedor()" [processing]="processing"> Transferir </app-api-button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL seleccionarVendedor -->
<app-modal-seleccionar-vendedor [origen]="VENDEDOR_ORIGEN" [multiple]="false" queryType="ONLY_RUT"
  (onSelectSingle)="onVendedorOrigenSeleccionado($event)" (onNotFound)="onVendedorOrigenNoEncontrado()">
</app-modal-seleccionar-vendedor>
<app-modal-seleccionar-vendedor [origen]="VENDEDOR_DESTINO" [multiple]="false" queryType="ONLY_RUT"
  (onSelectSingle)="onVendedorDestinoSeleccionado($event)" (onNotFound)="onVendedorDestinoNoEncontrado()">
</app-modal-seleccionar-vendedor>
